import { staticBlocks, homepageBlocks, orders, period } from '@/api/endpoints'

const fetchStaticBlock = blockCode => {
  return new Promise(resolve => {
    staticBlocks
      .getOne({ blockCode })
      .then(response => {
        const data = response.data.response

        resolve({
          success: true,
          data: {
            html: data.content,
            code: data.key,
            title: data.name
          }
        })
      })
      .catch(() => {
        resolve({
          success: false
        })
      })
  })
}
const fetchHomepageBlocks = () => {
  return new Promise(resolve => {
    homepageBlocks
      .get()
      .then(response => {
        const data = response.data.response
        resolve({
          success: true,
          data: data
        })
      })
      .catch(() => {
        resolve({
          success: false
        })
      })
  })
}

const fetchPeriods = (reverse) => {
  return new Promise((resolve) => {
    period
      .getAll(reverse)
      .then((response) => {
        const data = response.data.response
        resolve({
          success: true,
          data: data
        })
      })
      .catch(() => {
        resolve({
          success: false
        })
      })
  })
}
const fetchSuccessRates = (consultantId, filters) => {
  return new Promise(resolve => {
    const params = {
      ...filters
    }
    orders
      .getSuccessRates({ consultantId }, { params })
      .then(response => {
        if (response.data.success) {
          let data = response.data.response
          let items = []

          data.forEach(item => {
            items.push({
              from_date: new Date(item.from_date).toLocaleDateString(),
              to_date: new Date(item.to_date).toLocaleDateString(),
              success_rate: item.success_rate,
              orders_completed: item.orders_completed,
              orders_failed: item.orders_failed,
              jforce_level: item.jforce_level,
              penalty_perc: item.penalty_perc,
              hide_penalty: item.hide_penalty
            })
          })

          resolve({
            success: true,
            data: items
          })
        }
      })
      .catch(() => {
        resolve({
          success: false
        })
      })
  })
}

export {
  fetchStaticBlock,
  fetchHomepageBlocks,
  fetchSuccessRates,
  fetchPeriods
}
